import type { TaskType } from '@/store/templatesSlice';

export interface ProposedTask {
  key: string;
  title: string;
  type: TaskType;
  instruction: string;
  aiPrompts: string[];
  isRequired: boolean;
}

/**
 * Каталог «предложенных задач» — универсальные заготовки по типам задач.
 * Администратор добавляет одну или несколько и настраивает каждую
 * (заголовок, тип, обязательность, подсказку, ИИ-промпты).
 */
export const PROPOSED_TASKS: ProposedTask[] = [
  {
    key: 'photo',
    title: 'Фото',
    type: 'photo',
    instruction: '',
    aiPrompts: [],
    isRequired: true,
  },
  {
    key: 'text-input',
    title: 'Текст',
    type: 'text_input',
    instruction: '',
    aiPrompts: [],
    isRequired: true,
  },
  {
    key: 'checkbox',
    title: 'Да / Нет',
    type: 'checkbox',
    instruction: '',
    aiPrompts: [],
    isRequired: true,
  },
  {
    key: 'action',
    title: 'Действие',
    type: 'action',
    instruction: '',
    aiPrompts: [],
    isRequired: true,
  },
];
